import { createFileRoute } from '@tanstack/react-router'
import { teamsSearchSchema } from '../../../features/teams/search'
import { TeamsListPage } from '../../../features/teams/teams-list-page'

export const Route = createFileRoute('/_app/teams/')({
  validateSearch: teamsSearchSchema,
  component: TeamsListPage,
})
